import * as React from 'react';
import type { SVGProps } from 'react';

const IconReport = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 15" {...props}>
    <path
      fill="currentColor"
      d="M1.903.025H.952A.952.952 0 0 0 0 .976V14.3h1.903V7.17H9.75c.213 0 .33-.234.191-.389L7.234 3.75a.224.224 0 0 1 0-.303L9.94.414c.135-.154.022-.39-.191-.39H1.903Z"
    />
  </svg>
);
export default IconReport;
